import { Divider, FormHelperText, Grid, InputAdornment, InputLabel, Stack, TextField, Typography, Button } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import PageHeading from '../../Components/PageHeading';
import { useLocation, useNavigate } from 'react-router-dom';
import { PATH_NAME } from '../../Routes/Pathname';
import { HiOutlineMail } from 'react-icons/hi';
import { DatePicker, Select } from 'antd';
import { countries } from '../../Utils/countries';
import { timezones } from '../../Utils/timezones';
import CultService from '../../Services/CultService';
import toast from 'react-hot-toast';
import { HelperTexts } from '../../Utils/helper/HelperTexts';
import CountryCode from './Components/CountryCode';
import { DEPARTMENTS, GENDERS } from '../../Utils/helper/AppConstants';
import {
	sanitizeInput,
	validateEmail,
	validatUserEmail,
	validateOtherFields,
	validateUserEmail,
	validatePhoneNumber,
	isInputClean,
	getColorSettings,
} from '../../Utils/helper/commonUtils';
import { useSelector } from 'react-redux';
import { ArrowDownIcon, CloseIcon, EditIcon } from '../../Components/Icons/Icons';
import { isValidPhoneNumber } from 'libphonenumber-js';
import { CountryCodesList } from './Components/CountryCodesList';
import { AppColors } from '../../Utils/helper/AppColors';
import { Autocomplete } from '@mui/material';
import CustomAutoComplete from '../../Components/CustomAutoComplete';
import LabelledInput from '../../Components/LabelledInput';
import moment from 'moment';
import dayjs from 'dayjs';
import { FloatingLabelSelect } from '../../Components/FloatingLabelSelect';



export default function AddEditEmployee({ open, onClose, user, refreshList }) {
	const navigate = useNavigate();
	const { state } = useLocation();
	const company = useSelector((state) => state?.app?.company)?._id;
	// const edit = state?.user?._id;
	const edit = user?._id;

	const [details, setDetails] = useState({});
	const [countryCode, setCountryCode] = useState({});
	const [countryCodeAllInfo, setCountryCodeAllInfo] = useState(''); // { dial_code: '1', code: 'US', name: 'United States' } we get this from CountryCode component...
	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState({});

	const [depts, setDepts] = useState([]);

	console.log('countryCode inside AddEditEmployee', countryCode); 

	const employeeListPageDataCopy = useRef();
	// If there's a search query passed in the state (from the previous page), use it
	// useEffect(() => {
	// 	if (edit && state) {
	// 		employeeListPageDataCopy.current = state?.employeeListPageData;
	// 	}
	// }, [state?.employeeListPageData]);

	// Add this state at the top if not already present
	const [dateOfJoining, setDateOfJoining] = useState(null);

	// Handler for date change
	const handleDateOfJoining = (date) => {
		setDateOfJoining(date ? moment(new Date(date)).format('YYYY-MM-DD') : null);
		setDetails({ ...details, dateOfJoining: date ? moment(new Date(date)).format('YYYY-MM-DD') : null });
	};

	const handleInputChange = (e) => {
		setDetails({ ...details, [e.target.name]: e.target.value });
	};

	const getDepts = async () => {
		let res = await CultService.getFilterValues({ params: { companyId: company } });
		setDepts(res?.data?.departments);
	};

	useEffect(() => {
		if (company) getDepts();
	}, [company]);

	useEffect(() => {
		if (user?._id) {
			// const user = user;
			const countryName = user?.country;

			console.log('countryName', countryName);

			const foundCountry = CountryCodesList.find((c) => c.name.toLowerCase() === countryName?.toLowerCase());

			let cleanedPhoneNumber = user?.phoneNumber;

			if (foundCountry?.dial_code && cleanedPhoneNumber?.startsWith(foundCountry.dial_code)) {
				cleanedPhoneNumber = cleanedPhoneNumber.slice(foundCountry.dial_code.length);
			}

			const updatedDetails = {
				...user,
				phoneNumber: cleanedPhoneNumber,
			};

			setDetails(updatedDetails);

			console.log('foundCountry', foundCountry);

			if (foundCountry) {
				setCountryCode(foundCountry);
			}
		}
	}, [edit]);

	// const checkPhoneNumberBeforeUpdateorCreate = () => {
	// 	let number = details?.phoneNumber;

	//     console.log("countryCodeAllInfo : " , countryCodeAllInfo);
	// 	console.log(countryCode + number , " - " , countryCodeAllInfo?.code);

	// 	console.log(isValidPhoneNumber(countryCode + number, countryCodeAllInfo?.code))

	// 	if (countryCode && !isValidPhoneNumber(countryCode + number, countryCodeAllInfo?.code)) {
	// 		return `Check the phone number you provided it should be a valid phone number for ${countryCode}`;
	// 	}

	// 	return 'success';
	// };

	const handleCreate = async () => {
		setLoading(true);
		try {
			// const check = checkPhoneNumberBeforeUpdateorCreate();
			// if (check !== 'success') {
			// 	return toast.error(check);
			// }
			const data = {
				...details,
				company,
				phoneNumber: details?.phoneNumber ? countryCode?.dial_code + details?.phoneNumber : '',
			};
			let res = await CultService.createUser({ data });
			if (res.status == 200) {
				toast.success(HelperTexts.CREATED_SUCCESSFULLY);
				onClose(true);
				refreshList();
				// navigate(PATH_NAME.EMPLOYEES_LIST);
			}
		} catch (err) {
			toast.error(err?.response?.data?.details?.email?.properties?.message || HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
			setLoading(false);
		}
	};

	const handleUpdate = async () => {
		setLoading(true);
		try {
			// const check = checkPhoneNumberBeforeUpdateorCreate();
			// if (check !== 'success') {
			// 	return toast.error(check);
			// }
			let res = await CultService.updateUser({
				data: {
					...details,
					phoneNumber: details?.phoneNumber?.slice(0, 1) !== '+' ? countryCode?.dial_code + details?.phoneNumber : details?.phoneNumber,
				},
				params: { id: edit },
			});
			if (res.status == 200) {
				toast.success(HelperTexts.UPDATED_SUCCESSFULLY);
				onClose(true);
				refreshList();
				// navigate(PATH_NAME.EMPLOYEES_LIST);
				// navigate(PATH_NAME.EMPLOYEES_LIST, { state: { employeeListPageData: employeeListPageDataCopy?.current } });
			}
		} catch (err) {
			toast.error(err?.response?.data?.details?.email?.properties?.message || HelperTexts.SOMETHING_WENT_WRONG);
		} finally {
			setLoading(false);
		}
	};

	const setError = (e) => {
		if (e.target.name == 'email' && !validateUserEmail(e.target.value)) {
			setErrors({ ...errors, [e.target.name]: 'Invalid email format or contains unsafe characters' });
		} else if (e.target.name == 'phoneNumber' && (!validatePhoneNumber(e.target.value) || !isInputClean(e.target.value))) {
			setErrors({ ...errors, [e.target.name]: 'Invalid phone number' });
		} else {
			if (
				e.target.name !== 'email' &&
				e.target.name !== 'phoneNumber' &&
				(!isInputClean(e.target.value) || !validateOtherFields(e.target.value))
			) {
				setErrors({ ...errors, [e.target.name]: 'Contains unsafe characters' });
			} else {
				setErrors({ ...errors, [e.target.name]: null });
			}
		}
	};

	const hasError = () => {
		let res;
		if (Object.values(errors).some((value) => value !== null)) {
			res = true;
		} else {
			res = false;
		}
		return res;
	};

	const isDisabled = () => {
		let res = false;

		const phoneEntered = details.phoneNumber?.trim() || countryCode?.dial_code?.length !== 0;
		if (!phoneEntered) return true;
		const isPhoneInvalid =
			phoneEntered &&
			(!details.phoneNumber?.trim() ||
				countryCode?.dial_code?.length === 0 ||
				!isValidPhoneNumber(countryCode?.dial_code + details.phoneNumber, countryCodeAllInfo?.code));

		if (
			hasError() ||
			!details.firstName?.trim() ||
			!details.lastName?.trim() ||
			!details.email?.trim() ||
			// !details.gender?.trim() ||
			!details.timezone?.trim() ||
			!details?.dateOfJoining ||
			
			isPhoneInvalid
		) {
			res = true;
		}
		return res;
	};

	const handleSelectDepartment = (newValue) => {
		const selectedValue = newValue.slice(-1);
		setDetails({ ...details, department: selectedValue[0] });
		if (selectedValue.length && !depts.includes(selectedValue[0])) {
			setDepts([...depts, selectedValue[0]]);
		}
	};

	const localSettingColors = getColorSettings();

	return (
		<Stack sx={{ '& .MuiDivider-root': { my: 0 }, padding: 0 }}>
			<Stack p={2}>
				<PageHeading
					title={`${edit ? 'Edit' : 'Add'} Employee`}
					subTitle={
						edit ? 'Make changes fast and keep your data accurate.' : ' Capture essential info and register users in seconds.'
					}
					renderRight={<CloseIcon onClick={() => onClose(true)} />}
				/>
			</Stack>

			<Divider />

			<Stack direction={'column'} px={4} py={4} spacing={4}>
				<Grid container>
					<Grid item xs={5.8}>
						<TextField
							// required
							name="firstName"
							onBlur={setError}
							id="outlined-required"
							value={details?.firstName}
							error={errors?.firstName}
							helperText={errors?.firstName || ''}
							onChange={handleInputChange}
							size="small"
							fullWidth
							label="First Name"
							inputProps={{ maxLength: 50 }}
							InputLabelProps={{
								// // shrink: true,
								sx: { color: AppColors.HEADING_TITLE4, fontFamily: 'Poppins', fontWeight: 400, fontSize: 12 },
							}}
							sx={theme => ({
								'& .MuiOutlinedInput-root': {
									'& fieldset': {
										borderColor: theme.palette.primary.lightest_shade,
										borderRadius: '10px',
									},
									'&:hover fieldset': {
										borderColor: theme.palette.primary.lightest_shade,
										borderRadius: '10px',
									},
									'&.Mui-focused fieldset': {
										borderColor: theme.palette.primary.lightest_shade,
										borderRadius: '10px',
									},
									'& .MuiInputBase-input': {
										paddingTop: '7.5px',
										paddingBottom: '7.5px', // <-- Add this line
									},
								},
							})}
						/>
					</Grid>
					<Grid item xs={0.4} />
					<Grid item xs={5.8}>
						<TextField
							// required
							name="lastName"
							onBlur={setError}
							id="outlined-required"
							value={details?.lastName}
							error={errors?.lastName}
							helperText={errors?.firstName || ''}
							onChange={handleInputChange}
							size="small"
							fullWidth
							label="Last Name"
							inputProps={{ maxLength: 50 }}
							InputLabelProps={{
								// shrink: true,
								sx: { color: AppColors.HEADING_TITLE4 },
							}}
							sx={theme => ({
								'& .MuiOutlinedInput-root': {
									'& fieldset': {
										borderColor: theme.palette.primary.lightest_shade,
										borderRadius: '10px',
									},
									'&:hover fieldset': {
										borderColor: theme.palette.primary.lightest_shade,
										borderRadius: '10px',
									},
									'&.Mui-focused fieldset': {
										borderColor: theme.palette.primary.lightest_shade,
										borderRadius: '10px',
									},
									'& .MuiInputBase-input': {
										paddingTop: '7.5px',
										paddingBottom: '7.5px', // <-- Add this line
									},
								},
							})}
						/>
					</Grid>
				</Grid>

				<Grid container>
					<Grid item xs={5.8}>
						<TextField
							// required
							name="email"
							disabled={edit}
							onBlur={setError}
							id="outlined-required"
							value={details?.email}
							error={errors?.email}
							helperText={errors?.email || ''}
							onChange={handleInputChange}
							size="small"
							fullWidth
							label="Email"
							InputLabelProps={{
								// shrink: true,
								sx: { color: AppColors.HEADING_TITLE4 },
							}}
							sx={theme => ({
								'& .MuiOutlinedInput-root': {
									'& fieldset': {
										borderColor: theme.palette.primary.lightest_shade,
										borderRadius: '10px',
									},
									'&:hover fieldset': {
										borderColor: theme.palette.primary.lightest_shade,
										borderRadius: '10px',
									},
									'&.Mui-focused fieldset': {
										borderColor: theme.palette.primary.lightest_shade,
										borderRadius: '10px',
									},
									'& .MuiInputBase-input': {
										paddingTop: '7.5px',
										paddingBottom: '7.5px', // <-- Add this line
									},
								},
							})}
						/>
					</Grid>

					<Grid item xs={0.4} />
					{console.log('details', details)}
					<Grid item xs={5.8}>
						<CustomAutoComplete
							label="Gender"
							options={GENDERS.map((i) => {
								return {
									label: i.name,
									value: i.code,
								};
							})}
							value={details?.gender ? details.gender.charAt(0).toUpperCase() + details.gender.slice(1) : ''}
							onChange={(val) => setDetails({ ...details, gender: val.value })}
							// freeSolo={false}
							// disableClearable
						/>
					</Grid>
				</Grid>

				<Grid container>
					<Grid item xs={5.8}>
						{/* <CustomAutoComplete
							label="Department"
							options={depts}
							value={details?.department || ''}
							onChange={(val) => { console.log('val', val); setDetails({ ...details, department: val })}}
							setOptions={setDepts}
							freeSolo={true}
							// placeholder="Select or type to add"
							// You can pass InputLabelProps, sx, etc. as needed
						/> */}

						<FloatingLabelSelect
							label="Department"
							mode="tags"
							value={details?.department}
							onChange={handleSelectDepartment}
							allowClear
						>
							{depts?.map((option) => (
								<Select.Option key={option} value={option}>
									{option}
								</Select.Option>
							))}
						</FloatingLabelSelect>
					</Grid>
					<Grid item xs={0.4} />
					<Grid item xs={5.8}>
						<TextField
							// required
							name="role"
							onBlur={setError}
							id="outlined-required"
							value={details?.role}
							error={errors?.role}
							helperText={errors?.role || ''}
							onChange={handleInputChange}
							size="small"
							fullWidth
							label="Role"
							inputProps={{ maxLength: 100 }}
							InputLabelProps={{
								// shrink: true,
								sx: { color: AppColors.HEADING_TITLE4 },
							}}
							sx={theme => ({
								'& .MuiOutlinedInput-root': {
									'& fieldset': {
										borderColor: theme.palette.primary.lightest_shade,
										borderRadius: '10px',
									},
									'&:hover fieldset': {
										borderColor: theme.palette.primary.lightest_shade,
										borderRadius: '10px',
									},
									'&.Mui-focused fieldset': {
										borderColor: theme.palette.primary.lightest_shade,
										borderRadius: '10px',
									},
									'& .MuiInputBase-input': {
										paddingTop: '7.5px',
										paddingBottom: '7.5px',
									},
								},
							})}
						/>
					</Grid>
				</Grid>

				<Grid container>
					<Grid item xs={5.8}>
						<CustomAutoComplete
							label="Country"
							options={countries.map((i) => {
								return {
									label: i.name,
									value: i.name,
								};
							})}
							value={details?.country || ''}
							onChange={(val) => {
								console.log(val);
								setDetails({ ...details, country: val.value });
							}}
							// freeSolo={false}
							// disableClearable
						/>
					</Grid>
					<Grid item xs={0.4} />
					<Grid item xs={5.8}>
						<TextField
							// required
							id="outlined-required"
							label="Phone Number"
							helperText={
								details?.phoneNumber &&
								details?.phoneNumber?.length > 0 &&
								(!countryCode?.dial_code ? (
									<FormHelperText sx={{ color: 'red', display: 'flex', alignItems: 'center' }}>
										<span style={{ color: 'red', marginRight: '4px' }}>*</span>
										Please ensure that the phone numbers you provide include the correct country code
									</FormHelperText>
								) : (
									!isValidPhoneNumber(countryCode?.dial_code + details?.phoneNumber, countryCodeAllInfo?.code) && (
										<FormHelperText sx={{ color: 'red', display: 'flex', alignItems: 'center' }}>
											<span style={{ color: 'red', marginRight: '4px' }}>*</span>
											Check the phone number you provided, it should be valid for {countryCode?.dial_code}
										</FormHelperText>
									)
								))
							}
							InputLabelProps={{
								// shrink: true,
								sx: { color: AppColors.HEADING_TITLE4 },
							}}
							InputProps={{
								startAdornment: (
									<CountryCode
										countryCode={countryCode}
										setCountryCode={setCountryCode}
										setCountryCodeAllInfo={setCountryCodeAllInfo}
										isNeeded={details?.phoneNumber && details?.phoneNumber?.length > 1 && !countryCode?.dial_code}
									/>
								),
							}}
							onBlur={setError}
							// error={errors?.phoneNumber}
							value={details?.phoneNumber}
							fullWidth
							// placeholder="Enter Phone Number"
							size="small"
							name="phoneNumber"
							focused={details?.phoneNumber && countryCode?.dial_code}
							onChange={handleInputChange}
						/>
					</Grid>
				</Grid>

				<Grid container>
					<Grid item xs={5.8}>
						<CustomAutoComplete
							label="Timezone"
							options={timezones.map((i) => {
								return {
									label: i.zone,
									value: i.zone,
								};
							})}
							value={details?.timezone || ''}
							onChange={(val) => {
								setDetails({ ...details, timezone: val.value });
							}}
							// freeSolo={false}
							// disableClearable
						/>
					</Grid>
					<Grid item xs={0.4} />
					<Grid item xs={5.8}>
						<FloatingLabelSelect
							label="Date of Joining"
							value={details?.dateOfJoining ? dayjs(details?.dateOfJoining) : null}
							renderInput={({ onFocus, onBlur }) => (
								<DatePicker
									value={details?.dateOfJoining ? dayjs(details?.dateOfJoining) : null}
									format="DD-MMM-YYYY"
									onChange={handleDateOfJoining}
									getPopupContainer={(node) => node.parentNode}
									placeholder=""
									suffixIcon={<ArrowDownIcon color={localSettingColors.buttonBackground} size={11} />}
									style={{
										width: '100%',
										borderRadius: '10px',
										borderColor: localSettingColors.quinary,
										height: 40,
										fontFamily: 'Poppins',
										fontSize: 12,
										fontWeight: 400,
										lineHeight: '115%',
										paddingLeft: 12,
										paddingRight: 12,
									}}
									inputReadOnly
									maxDate={dayjs()}
									onFocus={onFocus}
									onBlur={onBlur}
								/>
							)}
						/>
					</Grid>
				</Grid>

				{/* <Divider /> */}

				<Stack direction="row" gap={2} justifyContent="center" alignItems="center" sx={{ pb: 2 }}>
					<Button
						variant="outlined"
						color="info"
						sx={{
							borderRadius: '4px',
							
							width: '130px',
							height: '42px',
						}}
						onClick={() => onClose(true)}
					>
						Cancel
					</Button>
					<Button
						disabled={isDisabled() || loading}
						sx={{
							borderRadius: '4px',
							px: '12px',
							py: '8px',
							width: '130px',
							height: '42px',
						}}
						variant="contained"
						color="info"
						onClick={edit ? handleUpdate : handleCreate}
					>
						Save
					</Button>
				</Stack>
			</Stack>
		</Stack>
	);
}
